(function () {
  'use strict';

  angular.module('lead.status').factory('LeadStatus', LeadStatus);

  LeadStatus.$inject = ['$resource'];

  function LeadStatus($resource) {
    return $resource(
      '/api/',
      {},
      {
        get: {
          method: 'GET',
          url: '/api/lead/status',
          isArray: true,
          cache: true,
        },
        update: { method: 'POST', url: '/api/lead/:id/update_status' },
      },
    );
  }
})();
